import { CollectionsService } from '../services/collections.service';

import { BaseStore } from './base.store';

export class CollectionsStore extends BaseStore<any> {
  constructor() {
    super(new CollectionsService(), 'CollectionsStore', 'Collections');
  }
}

export const collectionsStore: CollectionsStore = new CollectionsStore();
